import { render, staticRenderFns } from "./PriceAlertModal.vue?vue&type=template&id=6493a758&"
import script from "./PriceAlertModal.vue?vue&type=script&lang=js&"
export * from "./PriceAlertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports